<template>
  <div
    class="min-h-screen transition-colors duration-500"
    :class="pageBackgroundClass"
  >
    <main>
      <!-- Loading State -->
      <div
        v-if="loading"
        class="flex flex-col items-center justify-center min-h-[60vh]"
      >
        <div class="flex justify-center mb-5">
          <Vue3Lottie
            :animationLink="require('/assets/images/loader-round.jpg')"
            :height="100"
            :width="100"
            :speed="1.5"
          />
        </div>
        <!-- <p class="text-gray-500 mt-4">Verifying badge information...</p> -->
      </div>

      <!-- Error/Not Found State -->
      <div
        v-else-if="!vpDetails"
        class="flex flex-col items-center justify-center min-h-[60vh]"
      >
        <div
          class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4"
        >
          <i class="fas fa-exclamation-triangle text-red-500 text-2xl"></i>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-2">Badge not found</h2>
        <p class="text-gray-500 text-center max-w-md mb-8">
          The badge you're looking for doesn't exist or the link may be invalid.
          Please check the URL and try again.
        </p>
        <router-link
          to="/welcome"
          class="flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-xl hover:bg-primary/90 transition-colors shadow-lg font-medium"
        >
          <i class="fas fa-home"></i>
          Go to Home
        </router-link>
      </div>

      <!-- Badge Display -->
      <div v-else-if="vpDetails && vpDetails.verifiableCredentials">
        <div
          v-for="(vc, index) in vpDetails.verifiableCredentials"
          :key="index"
        >
          <vc-presentation :vc="vc" :lang="lang"></vc-presentation>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { ref, computed, inject } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router';

export default {
  name: 'Home',
  setup() {
    const route = useRoute();
    const api = inject('api');

    const vpDetails = ref(null);
    const lang = ref('en');
    const loading = ref(false);

    const isAnyExpired = computed(() => {
      if (!vpDetails.value?.verifiableCredentials) return false;
      return vpDetails.value.verifiableCredentials.some((vc) => {
        if (!vc.expirationDate) return false;
        return new Date(vc.expirationDate) < new Date();
      });
    });

    const pageBackgroundClass = computed(() => {
      if (!vpDetails.value?.verifiableCredentials) return 'bg-gray-50';
      return isAnyExpired.value ? 'page-bg-expired' : 'page-bg-valid';
    });

    try {
      if (route.query.code) {
        loading.value = true;
        api
          .getVPDetailsFromCode(route.query.code)
          .then((response) => {
            loading.value = false;
            vpDetails.value = response.data;
          })
          .catch((e) => {
            loading.value = false;
            console.log(e);
          });
      } else {
        router.push('/welcome');
      }

      if (route.query.lang) lang.value = route.query.lang;
    } catch (e) {
      console.log(e);
    }

    return { vpDetails, lang, loading, pageBackgroundClass };
  },
};
</script>

<style scoped>
.page-bg-valid {
  background: linear-gradient(
    180deg,
    #dbeafe 0%,
    #eff6ff 20%,
    #eff6ff 40%,
    #f8fafc 70%,
    #ffffff 100%
  );
}

.page-bg-expired {
  background: linear-gradient(
    180deg,
    #fee2e2 0%,
    #fef2f2 20%,
    #fff5f5 40%,
    #fffbfb 70%,
    #ffffff 100%
  );
}
</style>
